module.exports = __webpack_public_path__ + "img/4.a7f322b8.png";